import './commonAssets';

import '../common/stylesheets/modules/widgets/full-width-background-widget.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design-v2.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';
import '../common/javascripts/thirdparty/bootstrap/bootstrap.min.js';
import '../videoblocks/stylesheets/components/mixins.less';
import '../videoblocks/stylesheets/modules/search/tabbed-search.less';


import AppLoader from '../react/AppLoader/AppLoader';

import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import PortfolioContainer from '../react/ContributorPortfolio/containers/PortfolioContainer';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import VideoSiteConstants from '../react/common/SiteConstants/VideoSiteConstants';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [
    {
      name: 'Portfolio',
      path: new VideoSiteConstants().getPortfolioBasePath() + '/:username',
      component: PortfolioContainer,
    },
  ],
  auxApps: {
    ...NavApps,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'nps-modal': NPSModalLoaderContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
